import script from "./VColumn.vue?vue&type=script&setup=true&lang=ts"
export * from "./VColumn.vue?vue&type=script&setup=true&lang=ts"

import "./VColumn.vue?vue&type=style&index=0&id=11c5ac5a&lang=scss"

const __exports__ = script;

export default __exports__